import { Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';

const attributeData = [
    {
        attribute: "patient",
        name_th: "จำนวนผู้ป่วย",
        unit_th: "ราย",
        name_us: "Cases",
        unit_us: "head"
    },
    {
        attribute: "median",
        name_th: "มัธยฐาน 5 ปี",
        unit_th: "ราย",
        name_us: "Five years median",
        unit_us: "head"
    }
]

function CompareContent(props) {
    const { data } = props;

    return (
        <Grid container spacing={2}>
            <Grid xs={12} sx={{
                backgroundColor: 'rgb(62, 152, 211)'
            }}>
                <Typography variant="h5" className="mb-2 font-primary" sx={{
                    padding: 2,
                    paddingBottom: 0,
                    color: 'white'
                }}>
                    {
                        data.tambon_name !== undefined ?
                            `ต.${data.tambon_name}` :
                            data.amphur_name !== undefined ?
                                `อ.${data.amphur_name}` : `จ.${data.province_name}`
                    }
                </Typography>
                <Typography variant="h6" className="mb-2 font-primary" sx={{
                    fontWeight: 'normal',
                    paddingLeft: 2,
                    paddingRight: 2,
                    color: 'white'
                }}>
                    {
                        data.tambon_name !== undefined ?
                            `อ.${data.amphur_name} จ.${data.province_name}` :
                            data.amphur_name !== undefined ?
                                `จ.${data.province_name}` : ``
                    }
                </Typography>
            </Grid>
            <Grid xs={12} sx={{
                borderBottom: 'solid 1px rgba(0, 0, 0, 0.2)'
            }}>
                <Typography variant="subtitle1" className="font-primary" sx={{
                    color: 'black',
                    textAlign: 'center'
                }}>
                    {
                        `จำนวนผู้ป่วยเทียบค่ามัธยฐาน`
                    }
                </Typography>
                <Typography variant="h6" className="font-primary" sx={{
                    color: 'black',
                    textAlign: 'center',
                    fontWeight: 'normal'
                }}>
                    {data.result}
                </Typography>
            </Grid>
            {
                attributeData.map((attribute, index) =>  {
                    return (
                        <React.Fragment key={index}>
                            <Grid xs={7}>
                                <Typography variant='body1' className="font-primary" sx={{
                                    paddingLeft: 2
                                }}>
                                    {attribute.name_th}
                                </Typography>
                            </Grid>
                            <Grid xs={3}>
                                <Typography variant='body1' className="font-primary" sx={{
                                    textAlign: 'right'
                                }}>
                                    {data[attribute.attribute].toLocaleString()}
                                </Typography>
                            </Grid>
                            <Grid xs={2}>
                                <Typography variant='body1' className="font-primary">
                                    {attribute.unit_th}
                                </Typography>
                            </Grid>
                        </React.Fragment>
                    )
                })
            }
        </Grid>
    )
}

export default CompareContent
